import { useEffect, useState } from 'react'
import { Tabs } from 'components/FbUI/Tabs'
import { SelectLocationsForDealTable } from 'components/Tables/SelectLocationsForDealTable/SelectLocationsForDealTable'

// You may want to receive control as a prop for form integration
export const SelectDoorsSection = ({
  chainProxyId,
  initialDoorIds,
  onSelectedIdsChange,
  onSelectedCountChange,
  onNotSelectedCountChange,
}: {
  chainProxyId: number
  initialDoorIds?: number[]
  onSelectedIdsChange?: (ids: number[]) => void
  onSelectedCountChange?: (count: number) => void
  onNotSelectedCountChange?: (count: number) => void
}) => {
  const [selectedTab, setSelectedTab] = useState<'selected' | 'not_selected'>(
    'selected'
  )
  const [selectedCount, setSelectedCount] = useState(0)
  const [notSelectedCount, setNotSelectedCount] = useState(0)
  const [selectedIds, setSelectedIds] = useState<number[]>(initialDoorIds ?? [])

  useEffect(() => {
    onSelectedIdsChange?.(selectedIds)
  }, [selectedIds])

  useEffect(() => {
    onSelectedCountChange?.(selectedCount)
  }, [selectedCount])

  useEffect(() => {
    onNotSelectedCountChange?.(notSelectedCount)
  }, [notSelectedCount])

  useEffect(() => {
    if (initialDoorIds) {
      setSelectedIds(initialDoorIds)
    }
  }, [initialDoorIds])

  return (
    <>
      <Tabs
        tabs={[
          {
            key: 'selected',
            title: (
              <div>
                <b>Selected ({selectedCount})</b>
              </div>
            ),
          },
          {
            key: 'not_selected',
            title: (
              <div>
                <b>Not Selected ({notSelectedCount})</b>
              </div>
            ),
          },
        ]}
        selectedTab={selectedTab}
        setSelectedTab={(value) => {
          setSelectedTab(value)
        }}
        tabStyle={{ width: '180px' }}
      />
      <div className={selectedTab === 'selected' ? '' : 'hidden'}>
        <SelectLocationsForDealTable
          chainProxyId={chainProxyId}
          tableKey="SELECT_LOCATIONS"
          filterIdentifierModifier="-selected"
          type="selected"
          setTotalRowsCount={setSelectedCount}
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
        />
      </div>
      <div className={selectedTab === 'not_selected' ? '' : 'hidden'}>
        <SelectLocationsForDealTable
          chainProxyId={chainProxyId}
          tableKey="SELECT_LOCATIONS"
          filterIdentifierModifier="-unselected"
          type="not_selected"
          setTotalRowsCount={setNotSelectedCount}
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
        />
      </div>
    </>
  )
}
